import { render, staticRenderFns } from "./WalletTransaction.vue?vue&type=template&id=3c11ad13&"
import script from "./WalletTransaction.vue?vue&type=script&lang=ts&"
export * from "./WalletTransaction.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports